import { IViewerFloor } from "../interfaces/IViewerFloor";
import { IFloor } from "../interfaces/spaces";

export class AutodeskViewer {
	private readonly options3d: Autodesk.Viewing.AggregatedViewInitOptions = {};

	public view: Autodesk.Viewing.AggregatedView;

	public visualizer?: Autodesk.Extensions.DataVisualization;

	public constructor() {
		this.view = new Autodesk.Viewing.AggregatedView();
	}

	public get dataVizCore(): typeof Autodesk.DataVisualization.Core {
		return Autodesk.DataVisualization.Core;
	}

	public get viewer(): Autodesk.Viewing.GuiViewer3D {
		return this.view.viewer as Autodesk.Viewing.GuiViewer3D;
	}

	public async initAsync(element: HTMLDivElement): Promise<void> {
		await this.view.init(element, this.options3d);

		console.log("Using @beyondeyes/shared version [VI]{version} - {date}[/VI]"); // Rollup inserts data during build

		this.visualizer = (await this.viewer.loadExtension("Autodesk.DataVisualization")) as Autodesk.Extensions.DataVisualization;

		this.viewer.disableHighlight(true);
		this.viewer.set2dSelectionColor(new THREE.Color(1, 0, 0), 0);
		this.viewer.setTheme("be-theme");
	}

	public openViewAsync(viewerFloor: IViewerFloor): Promise<Autodesk.Viewing.Model[]> {
		this.view.unloadAll();
		return this.view.switchView([viewerFloor.node], undefined);
	}

	public async clearViewAsync(): Promise<void> {
		await this.view.switchView([], undefined);
	}

	public getView(viewerFloor: IViewerFloor): Autodesk.Viewing.Model {
		return this.view.getModel(viewerFloor.node);
	}

	private onDocumentLoadFailure(): void {
		console.error("Failed to load viewer", arguments);
	}

	public initModelByDocumentIdAsync(floor: IFloor, onDocumentLoadFailure?: (errorCode: any, errorMsg: string, floor: IFloor) => void): Promise<IViewerFloor> {
		return new Promise<IViewerFloor>((resolve) => {
			Autodesk.Viewing.Document.load(
				`urn:${floor.urn}`,
				(doc: Autodesk.Viewing.Document) => {
					const nodes = doc.getRoot().search({ type: "geometry" });
					resolve({
						floor: floor,
						node: nodes[0],
					});
				},
				(errorCode: Autodesk.Viewing.ErrorCodes, errorMessage: string) => {
					if (onDocumentLoadFailure) {
						onDocumentLoadFailure(errorCode, errorMessage, floor);
					} else {
						this.onDocumentLoadFailure();
					}
				}
			);
		});
	}
}
